// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + ({"3334":"app-theme-dark1","6522":"app-theme-dark0","7641":"app-theme-light0","9554":"app-theme-light1"}[chunkId] || chunkId) + "." + {"3334":"b2f92386","4546":"e58a2ac1","6522":"8f26b516","7641":"3c1fe257","9554":"f87f1b00","9660":"eac69cb3"}[chunkId] + ".chunk.css";
};